import { render, staticRenderFns } from "./资产招商详情.vue?vue&type=template&id=4f85e21c&scoped=true"
import script from "./资产招商详情.vue?vue&type=script&lang=js"
export * from "./资产招商详情.vue?vue&type=script&lang=js"
import style0 from "./资产招商详情.vue?vue&type=style&index=0&id=4f85e21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f85e21c",
  null
  
)

export default component.exports